<template>
  <div class="recommend">
    <order-list v-model="checked" :orderList="orderList" :expire="expire" ref="drugOrederList"></order-list>
    <van-empty
      v-if="!orderList.length && !load"
      description="暂无商品"
      image="https://static.91jkys.com/attachment/20210428105356694_a8c6c937d65640aaae9cf82b8c4af801.png"
    ></van-empty>
    <fixed-bottom
      v-show="!expire && !load"
      :checked="checked"
      ref="fixedBottom"
      :totalCountPrice="totalCountPrice"
      @handleCheckAll="handleCheckAll"
      :retry="retry || retryInner"
      @submit="submit"
    ></fixed-bottom>
  </div>
</template>
<script>
import FixedBottom from './components/fixedBottom';
import OrderList from './components/orderList';
import jumpCenter from '@/mixins/jumpCenter';
import { getAdapter } from '@zyf2e/adapt';

export default {
  mixins: [jumpCenter],
  components: {
    FixedBottom,
    OrderList
  },
  data() {
    return {
      orderList: [],
      load: false,
      expire: false,
      retry: this.$route.query.retry == 1,
      retryInner: false,
      checked: [] // 购物车选中
    };
  },
  computed: {
    totalCountPrice() {
      return this.orderList.reduce(
        (pre, cur) => (this.checked.indexOf(cur.itemId) !== -1 ? pre + cur.realPrice * cur.amount : pre),
        0
      );
    }
  },
  watch: {
    checked() {
      const len = this.orderList.filter((item) => item.stockNum && !item.status).length;
      if (len) this.$refs.fixedBottom.checkedAll = this.checked.length === len;
    }
  },
  created() {
    this.fetchCartList();
    const { settlementId } = this.$route.query;
    const timeStamp = new Date().getTime();
    Telescope.trackEvent({ trackId: 'zyyd-click-fytjd-ckqr', custom: { settlementId, timeStamp } });
  },
  methods: {
    handleCheckAll(checkedAll) {
      if (!this.$refs.drugOrederList) return;
      const len = this.orderList.filter((item) => item.stockNum && !item.status).length;
      if (checkedAll) {
        this.$refs.drugOrederList.toggleAll(checkedAll);
      } else {
        if (this.checked.length === len) this.$refs.drugOrederList.toggleAll();
      }
    },
    async fetchCartList() {
      this.load = true;
      const { settlementId } = this.$route.query;
      const { itemList, repeatSubmit, toastMsg } = await this.$fetch.fetchGetSettlementList({ settlementId });
      this.orderList = itemList;
      if (repeatSubmit === 1) {
        this.$toast(toastMsg);
        this.load = false;
        this.expire = true;
        return;
      }

      this.$nextTick(() => {
        this.$refs.drugOrederList.toggleAll(true);
      });
      this.load = false;
    },
    reSubmit(detail) {
      // submitTrolley
      const { settlementId } = this.$route.query;

      this.$fetch
        .submitTrolley({
          type: 'submitTrolley',
          detail,
          isDrug: 0,
          settlementId
        })
        .then((res) => {
          const { status, requirementId } = res;

          if (status === 1) {
            window.wx.closeWindow();
            return;
          }
          if (status === 3) {
            this.saveDataAndToPreOrder({
              settlementId: requirementId,
              isDrug: '0',
              bizType: 'need',
              bizId: requirementId
            });
            // this.requestPreOrderAndJumpToPlaceOrder(
            //   { orders: detail, bizType: 'need', bizId: requirementId },
            //   { settlementId: requirementId, isDrug: '0' }
            // );
            return;
          }
          this.$router.push({
            name: 'BindingDoctors',
            query: { requirementId, isDrug: '0' }
          });
        });
    },

    submit() {
      const { settlementId } = this.$route.query;

      const detail = this.orderList.filter((item) => this.checked.indexOf(item.itemId) !== -1);

      if (this.retry) {
        this.reSubmit(detail);
        return;
      }

      this.$fetch.fetchSubmitSettlementList({ settlementId, submitDetails: detail }).then((res) => {
        const { canBuy, trolleyModels, doctorId, toastMsg, repeatSubmit } = res;

        if (canBuy) {
          this.saveDataAndToPreOrder({
            settlementId,
            doctorId,
            isDrug: '0',
            bizType: 'need',
            bizId: settlementId
          });
          // this.requestPreOrderAndJumpToPlaceOrder(
          //   { orders: detail, bizType: 'need', bizId: settlementId },
          //   { doctorId, settlementId, isDrug: '0' }
          // );
        } else {
          this.$toast(toastMsg);
          this.retryInner = true;
          if (trolleyModels) {
            this.orderList = trolleyModels;
          }

          this.$nextTick(() => {
            // 商品申请单 视图滚到第一个已经售磬 或者 状态改变 导致不能购买的场景
            const item = this.orderList.filter((item) => item.amount !== item.itemNum || item.status === 1)[0];
            if (item) this.$refs.drugOrederList.scrollIntoView(item.itemId);
            const len = this.orderList.filter((item) => item.stockNum && !item.status).length;
            if (len) this.$refs.fixedBottom.checkedAll = true;
            this.$refs.drugOrederList.toggleAll(true);
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.recommend {
  .tips {
    background: #fff;
    font-size: 14px;
    height: 38px;
    line-height: 38px;
    padding: 0 16px;
    color: #8c8c8c;
  }
}
</style>
